import { useNavigate } from "react-router-dom";

import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

interface ItemNotAppliedToCartModalProps {
  onClose: () => void;
  itemType: "reward" | "offer";
}

export const ItemNotAppliedToCartModal = ({
  onClose,
  itemType,
}: ItemNotAppliedToCartModalProps) => {
  const navigate = useNavigate();

  return (
    <ActionModal
      size="small"
      open={true}
      onClose={onClose}
      onFirstButtonClick={() => navigate("/shop")}
      firstButtonLabel="Shop Now"
      title={`This ${itemType} cannot be redeemed yet.`}
      description={`You can redeem it once you have at least one valid item in your cart - shop now to add to your cart and redeem this ${itemType}!`}
    />
  );
};
